import React, { Component } from 'react';
import { Helmet } from 'react-helmet';

import '../../assets/scss/Wallet/taxRule.scss';

class TaxRule extends Component {
  render () {
    return (
      <div>
        <Helmet><title>扣税规则</title></Helmet>
        <div className='taxRule'>
          <div className='taxRule-title'>劳务所得税扣税规则</div>
          <ul>
            <li className='head'>
              <div>预扣预缴应纳所得税额</div>
              <div>预扣预缴应纳所得税额</div>
              <div>应纳税额</div>
            </li>
            <li>
              <div>＜=800</div>
              <div>不缴纳</div>
              <div>-</div>
            </li>
            <li>
              <div>＜=4000且＞800</div>
              <div>含税劳务报酬所得-800</div>
              <div>预扣预缴应纳所得税额×20%</div>
            </li>
            <li>
              <div>＜=20000且＞4000</div>
              <div>含税劳务报酬所得×(1-20%)</div>
              <div>预扣预缴应纳所得税额×20%</div>
            </li>
            <li>
              <div>＜=50000且＞20000</div>
              <div>含税劳务报酬所得×(1-20%)</div>
              <div>预扣预缴应纳所得税额×30%-2000</div>
            </li>
            <li>
              <div>＞50000</div>
              <div>含税劳务报酬所得×(1-20%)</div>
              <div>预扣预缴应纳所得税额×40%-7000</div>
            </li>
          </ul>
          <div className='taxRule-title '>举例如下</div>
          <ul>
            <li className='head'>
              <div>含税劳务报酬所得</div>
              <div>预扣预缴应纳所得税额</div>
              <div>应纳税额</div>
            </li>
            <li>
              <div>700</div>
              <div>0</div>
              <div>0</div>
            </li>
            <li>
              <div>1200</div>
              <div>400</div>
              <div>80</div>
            </li>
            <li>
              <div>25000</div>
              <div>20000</div>
              <div>4000</div>
            </li>
            <li>
              <div>62500</div>
              <div>50000</div>
              <div>13000</div>
            </li>
            <li>
              <div>63000</div>
              <div>50400</div>
              <div>13160</div>
            </li>
          </ul>
        <div className='taxRule-title'>说明</div>
        <div className='explain'>1、扣税是以人按月进行统计，在提现时扣税，扣税金额可在交易明细中查看；</div>
        <div className='explain'>2、若存在跨越多月提现的情况，会在提现时一次扣除过往月份产生的所得税；</div>
        <div className='explain'>3、一个人在挣推系统存在多账号的情况下，所得税会合并计算，扣税金额会根据每个账户的交易情况在提现时单独展示。</div>
        </div>
      </div>
    )
  }
}

export default TaxRule;